var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-post-container",on:{"click":_vm.onClickPost}},[_c('icon-svg',{staticClass:"icon-post",attrs:{"icon-class":"add"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }